module.exports = __webpack_public_path__ + "img/autowash-24hours.301e752c.png";